"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTING_OWNER = void 0;
const siteType_1 = require("./siteType");
exports.SETTING_OWNER = Object.assign(Object.assign({}, siteType_1.SITE_TYPE), { PAGE: 'PAGE', AUTORESPONDER: 'AUTORESPONDER', CAMPAIGN: 'CAMPAIGN' });
//# sourceMappingURL=settingOwner.js.map